<div class="vertical-tabs-container">  
  <mat-tab-group class="vertical-tab-group" (selectedTabChange)="onTabChange($event)">
    @for(tab of  ActiveTabs(); track $index){
    <mat-tab [label]="tab.label">
      <ng-template matTabContent>
        <ng-template appDynamicHost></ng-template>
      </ng-template>
    </mat-tab>
    }
  </mat-tab-group>
</div>
